import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';
import moment from 'moment'


import Vue from 'vue'


const getDefaultStateForDocPrintOuts = () => {
  return {
    printouts: [],
    data:{}
  }
}

// state
const state = getDefaultStateForDocPrintOuts()

// getters
const getters = {

}

// mutations
const mutations = {
    FETCH_ALL(state, data){
        data.forEach(function(element) {
            element.time_printed = (element.time_printed != null && element.time_printed != '') ? (moment(element.time_printed).format('DD/MM/YYYY, h:mm a')) : '-'
        });
        state.printouts = data
    },
    RESET_STATE_FOR_DOC_PRINTOUTS (state) {
      Object.assign(state, getDefaultStateForDocPrintOuts())
    },
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
      commit("RESET_STATE_FOR_DOC_PRINTOUTS")
    },
    fetchAll({ commit }, data) {
        return axios.post(apiRoutes['GET_DOCUMENT_PRINTOUTS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH_ALL', response.data.data)
              } else {
                commit('FETCH_ALL', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    }
}

export {
    state,
    getters,
    actions,
    mutations
}
